import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
   providedIn: 'root',
})
export class FeaturebaseService {
   private isBrowser: boolean;
   constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
      this.isBrowser = isPlatformBrowser(this.platformId);
   }

   getFeatureBaseData() {
      return this.http.get<any>(
         `${environment.apiUrl}/api/featurebase/changelog`
      );
   }

   openWhatsNew() {
      if (this.isBrowser) {
         window.postMessage({
            target: 'FeaturebaseWidget',
            data: {
              action: 'changePage',
              payload: 'MainView',
              openWidget: true,
            },
          }, '*')
      }
   }

   openFeatureBaseArticle(id: string) {
      if (this.isBrowser) {
         if (window?.Featurebase) {
            // Manually open the widget and load a specific article/changelog/blog
            window.Featurebase('open_portal_widget');
         } else {
            setTimeout(() => {
               this.openFeatureBaseArticle(id);
               console.log('Featurebase not found');
            }, 1000);
         }
      }
   }
}
